@if (errorMessage) {
  <div class="row text-center">
    <div class="col">
      <span class="wre-form-error">
        {{ errorMessageInfo }}
      </span>
    </div>
  </div>
}

@if (!loading && user) {
  <div class="row">
    <div class="col-md-12">
      <div class="summary-bar border-bottom d-flex align-items-center">
        <label class="form-control-label"> User Name: </label>
        <span
          class="summary-detail"
          wreToolkitTitleWhenTruncated
          ngbTooltip
          container="body"
          placement="bottom">
          @if (user.displayName && user.displayName.trim() === ',') {
            <span> &#x2015; </span>
          }
          @if (user.displayName && user.displayName.trim() !== ',') {
            <span>
              {{ user.displayName }}
            </span>
          }
        </span>
        @if (user.email) {
          <label class="form-control-label border-start ms-3 ps-3"> Email Address: </label>
        }
        @if (user.email) {
          <span
            class="summary-detail"
            wreToolkitTitleWhenTruncated
            ngbTooltip
            container="body"
            placement="bottom">
            {{ user.email }}
          </span>
        }
      </div>
    </div>
  </div>
}

<div class="row">
  @if (loading) {
    <div class="col-md-12" style="height: 90vh">
      <div class="d-flex justify-content-center align-items-center h-100 w-100">
        <div class="loading" [hidden]="errorMessage"></div>
      </div>
    </div>
  }
</div>

@if (!loading && user) {
  <div class="user-details-cont">
    <ul ngbNav #nav="ngbNav" activeId="Gateway" class="nav-tabs">
      <li ngbNavItem="Gateway">
        <a ngbNavLink>Gateway</a>
        <ng-template ngbNavContent>
          <div class="row">
            <div class="col">
              <div class="wre-tab-container">
                @if (gatewayApplications && gatewayApplications.length > 0) {
                  <div>
                    @for (application of gatewayApplications; track application) {
                      <div>
                        <wre-user-app-details
                          [application]="application"
                          displayName="Gateway"></wre-user-app-details>
                      </div>
                    }
                  </div>
                }
                @if (gatewayApplications && gatewayApplications.length === 0) {
                  <div class="pt-3">No Roles assigned.</div>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="Reporting">
        <a ngbNavLink>Reporting</a>
        <ng-template ngbNavContent>
          <div class="row">
            <div class="col">
              <div class="wre-tab-container">
                @if (reportingApplications && reportingApplications.length > 0) {
                  <div>
                    @for (application of reportingApplications; track application) {
                      <div>
                        <wre-user-app-details
                          [application]="application"
                          displayName="Interactive Reports">
                        </wre-user-app-details>
                      </div>
                    }
                  </div>
                }
                @if (reportingApplications && reportingApplications.length === 0) {
                  <div class="pt-3">No Roles assigned.</div>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="Quality">
        <a ngbNavLink>Quality</a>
        <ng-template ngbNavContent>
          <div class="row">
            <div class="col">
              <div class="wre-tab-container">
                @if (rqmApplications && rqmApplications.length > 0) {
                  <div>
                    @for (application of rqmApplications; track application) {
                      <div>
                        <wre-user-app-details
                          [application]="application"
                          displayName="SAFR"></wre-user-app-details>
                      </div>
                    }
                  </div>
                }
                @if (rqmApplications && rqmApplications.length === 0) {
                  <div class="pt-3">No Roles assigned.</div>
                }
              </div>
            </div>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="Compliance">
        <a ngbNavLink>Compliance</a>
        <ng-template ngbNavContent>
          <div class="row">
            <div class="col">
              <div class="wre-tab-container">
                @if (sanctionsApplications?.length > 0) {
                  <div>
                    @for (application of sanctionsApplications; track application) {
                      <div>
                        @if (application.applicationName === 'wre-sanctions') {
                          <wre-user-app-details
                            [application]="application"
                            displayName="Sanctions Identification Tool"></wre-user-app-details>
                        }
                        @if (application.applicationName === 'wre-referral') {
                          <wre-user-app-details
                            [application]="application"
                            displayName="Sanctions Referral Tool"></wre-user-app-details>
                        }
                      </div>
                    }
                  </div>
                } @else {
                  @if (rqmApplications && rqmApplications.length === 0) {
                    <div class="pt-3">No Roles assigned.</div>
                  }
                }
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>
  </div>
}
